module.exports = __webpack_public_path__ + "static/szenario4_3-d57b372c1f911ff7230a0dedd03d12e2.png";